import { getWeekSeconds } from "./getWeekSeconds";
import { DayIndex } from "@kanpla/types";

export const dayIndexesArr = [0, 1, 2, 3, 4] as const;

export const getDayIndexFromSeconds = (seconds: number) => {
  const mondaySeconds = getWeekSeconds(seconds);
  const secondsDifference = seconds - mondaySeconds;
  const daysDifference = (secondsDifference / 86400) as DayIndex;
  return daysDifference;
};
